import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SecurityService} from '../../../shared/services/security/security.service';
import {CustomWidgetData} from "../../../shared/types/custom-widgets/custom-widget-data";
import {ENTRY_STATES} from "../../../shared/types/entry/EntryStatesEnum";
import {AddCustomWidgetService} from "../../../shared/services/custom-widgets/add-custom-widget.service";
import {UserRole} from "../../../shared/types/userrole/user-role";
import {TranslateService} from "@ngx-translate/core";
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'wsd-organization-custom-widgets',
  templateUrl: './organization-custom-widgets-component.html',
  styleUrls: ['./organization-custom-widgets-component.css']
})
export class OrganizationCustomWidgetsComponent implements OnInit {

  @Input()
  parentForm: FormGroup;

  @Input()
  widgets: CustomWidgetData[] = [];

  @Input()
  organizationId: number;

  @Output()
  onNewWidget = new EventEmitter();

  @Output()
  onWidgetDelete = new EventEmitter();

  pageSize: number = 10;

  constructor(private addCustomWidgetService: AddCustomWidgetService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.initWidgetList();
  }

  add() {
    this.addCustomWidgetService.create();
  }

  modify(widget: CustomWidgetData) {
    this.addCustomWidgetService.modify(widget);
  }

  delete(widget: CustomWidgetData) {
    this.widgets.splice(this.widgets.indexOf(widget), 1);
    this.parentForm.get("widgets").setValue(this.widgets);
    this.onWidgetDelete.emit();
  }

  onSave(widget: CustomWidgetData) {
    widget.organizationId = this.organizationId;
    if (widget.$state === ENTRY_STATES.NEW) {
      this.widgets.push(widget);
      this.onNewWidget.emit();
    } else {
      this.addCustomWidgetService.modify(widget);
      this.onNewWidget.emit();
    }
  }

  initWidgetList() {
    if (this.widgets) {
      for (let i = 0; i < this.widgets.length; i++) {
        let widget = this.widgets[i];
        if (!widget.orderNumber) {
          widget.orderNumber = i;
        }
      }
      this.widgets.sort((a, b) => (a.orderNumber > b.orderNumber ? 1 : -1));
      this.parentForm.get("widgets").setValue(this.widgets);
    }
  }

  moveWidgetUp(widget: CustomWidgetData) {
    let originIndex = widget.orderNumber;
    let newIndex = originIndex - 1;
    widget.orderNumber = newIndex;
    this.widgets[newIndex].orderNumber = originIndex;
    this.widgets.sort((a, b) => (a.orderNumber > b.orderNumber ? 1 : -1));
    this.parentForm.get("widgets").setValue(this.widgets);
  }

  moveWidgetDown(widget: CustomWidgetData) {
    let originIndex = widget.orderNumber;
    let newIndex = originIndex + 1;
    widget.orderNumber = newIndex;
    this.widgets[newIndex].orderNumber = originIndex;
    this.widgets.sort((a, b) => (a.orderNumber > b.orderNumber ? 1 : -1));
    this.parentForm.get("widgets").setValue(this.widgets);
  }

  getRoles(roleList: UserRole[]): string {
    let roleName = '';
    if(roleList.length == 7) {
      roleName = this.translate.instant('WS_DIRECTORY.ORG_MODIFY.CUSTOM_WIDGETS.ALL_ROLES_SELECTED');
      return roleName;
    } else {
      for (let role of roleList) {
        roleName = roleName + role.name + ', ';
      }
      return roleName.slice(0, roleName.lastIndexOf(','));
    }


  }

}
